module.exports = __webpack_public_path__ + "img/ic_close_secondary.d03ddc9c.svg";